import { useQueryClient } from 'react-query';
import { useMutation } from '@frontend/react-query-helpers';
import { SchemaFeatureFlags } from '@frontend/schema';
import { useLocationService } from '@frontend/wam-location-service';
import { Modal, ModalControlModalProps, SwitchField, TextField, useFormField } from '@frontend/design-system';

export const CreateNewFeatureFlag = ({ ...modalProps }: ModalControlModalProps) => {
  const queryClient = useQueryClient();
  const { currentLocation } = useLocationService();

  const nameFieldProps = useFormField({
    type: 'text',
  });
  const descriptionProps = useFormField({
    type: 'text',
  });

  const switchProps = useFormField({
    type: 'switch',
  });

  const { mutate } = useMutation({
    mutationFn: () =>
      SchemaFeatureFlags.CreateFlag({
        flag: {
          name: nameFieldProps.value,
          description: descriptionProps.value,
          defaultValue: switchProps.value,
        },
      }),
    onSuccess: () => {
      modalProps.onClose();
      queryClient.invalidateQueries([currentLocation?.locationId, 'feature-flags']);
    },
  });

  return (
    <Modal {...modalProps} minWidth={400}>
      <Modal.Header onClose={modalProps.onClose}>Add New Feature Flag</Modal.Header>
      <Modal.Body>
        <TextField {...nameFieldProps} name='name-field' label='Name' />
        <TextField {...descriptionProps} name='description-field' label='Description' />
        <SwitchField {...switchProps} name='switch' label='Enabled by default' />
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: 'Create Flag',
          onClick: () => {
            mutate();
          },
        }}
        secondary={{
          label: 'Cancel',
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};
